module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_iii"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "title"
  }, [_vm._v("W"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ITH A")])]), _vm._v(" "), _c('h1', {
    staticClass: "titlea_j"
  }, [_vm._v("R"), _c('span', {
    staticClass: "smallcaps1"
  }, [_vm._v("OYAL")]), _vm._v(" E"), _c('span', {
    staticClass: "smallcaps1"
  }, [_vm._v("NGINEERS")]), _vm._v(" F"), _c('span', {
    staticClass: "smallcaps1"
  }, [_vm._v("IELD")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps1"
  }, [_vm._v("OMPANY")])]), _vm._v(" "), _c('h1', {
    staticClass: "titlea"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IN")]), _vm._v(" F"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RANCE &")]), _vm._v(" I"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("TALY")])]), _vm._v(" "), _c('p', {
    staticClass: "sub-title"
  }, [_vm._v("A"), _c('span', {
    staticClass: "smallcaps1"
  }, [_vm._v("PRIL")]), _vm._v(" 1915 "), _c('span', {
    staticClass: "smallcaps1"
  }, [_vm._v("TO THE")]), _vm._v(" A"), _c('span', {
    staticClass: "smallcaps1"
  }, [_vm._v("RMISTICE")])]), _vm._v(" "), _c('p', {
    staticClass: "author"
  }, [_vm._v("V. F. EBERLE")]), _vm._v(" "), _c('div', {
    staticClass: "img_container_j"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/pub.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ff41c7f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/03_Title.vue
// module id = 63
// module chunks = 0